var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"team"},[_c('div',{staticClass:"main"},[_c('div',[_c('h1',[_vm._v("We are still gathering our team.")]),_vm._v(" "),_c('p',[_vm._v("Please come back later or shoot us a message! "),_c('router-link',{attrs:{"to":'/team/join'}},[_vm._v("Interested in joining?")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7d6583c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Team.vue
// module id = null
// module chunks = 